import { defineStore } from 'pinia'

/** 坐席在线状态：菜单「客服工作台」用它实时显示状态标签 */
export type CsAgentPresence = 'offline' | 'idle' | 'busy' | 'away'

const PRESENCE_LABEL: Record<CsAgentPresence, string> = {
  offline: '离线',
  idle: '在线',
  busy: '忙碌',
  away: '离席'
}

export const useCsAgentStore = defineStore('csAgent', {
  state: () => ({
    presence: 'offline' as CsAgentPresence,
    /** 补充说明（通话中 / 待写小结），供全局「工作中」浮层展示 */
    detail: ''
  }),
  getters: {
    online: (state) => state.presence !== 'offline',
    label: (state) => PRESENCE_LABEL[state.presence]
  },
  actions: {
    setPresence(next: CsAgentPresence) {
      this.presence = next
    },
    setDetail(detail: string) {
      this.detail = detail
    }
  }
})
